import { getCoreDataSecurityApplicationsObjectsSlice } from './get';

export const { requestGetCoreDataSecurityApplicationsObjects, resetGetCoreDataSecurityApplicationsObjects } =
	getCoreDataSecurityApplicationsObjectsSlice.asyncActionCreators;
